
<div style="display: flex; flex-direction: column; height: calc(100% - 50px);">
    <div style="height: 100vh;">
    </div>
    <div style="align-self: flex-end; display: flex; flex-direction: column;">
        <div style="align-self: flex-end; margin: 0 auto 40px auto;" class = "talk-bubble">
            <span [innerHTML]="(global.getCoachTxt) ? global.getCoachTxt : bubbleText"></span>
        </div>
        <img style="width: 50vw; height: 40vh;" src="../../../assets/imgs/guide-image.png" />
    </div>
</div>
